export default "__VITE_ASSET__cef1717e__"